<script>
  import { tempStore } from "../../../stores/temp.store";
  import { userStore } from "../../../stores/user.store";
  import { hooksStore } from "../../../stores/hooks.store";

  import Icon from "../../../components/Icon/Icon.svelte";
  import {
    sourceExists,
    nastavViditelnostVrstvy,
    zobrazDataNaMape,
    vygenerujIdZdroja,
    pointTo,
  } from "../../../helpers/map";
  import {
    vratVrstvyMapyPodlaTypu,
    vratKodFarbyPodlaTypu,
  } from "../../../helpers/config";
  import { vratGeojsonData } from "../../../api/geojson";
  import { tableItemLinkClick } from "./datagrid.func";

  import { get as get_store } from "svelte/store";
  import { onDestroy, onMount } from "svelte";
  import get from "get-value";

  export let data;

  const temp = get_store(tempStore);
  let timeout = get(temp, "eventsTimeout", 0);
  const dest = data.destination;
  let typ, tab;
  [typ, tab] = dest.split("/");
  const id = data.id;
  const nazov = data.title;

  const source_id = typ && id ? vygenerujIdZdroja(typ, id) : false;

  let user = [];
  let element;
  let unsubscribeUserStore = userStore.subscribe((store) => {
    user = get(store) || {};
  });

  const mouseOver = function (event) {
    if (!typ || !id) {
      return false;
    }

    if (!source_id) {
      return false;
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    let stav = get(user, "options.mapa.stav", false) || {};
    if (get(stav[source_id]) === undefined) {
      event.preventDefault();
      event.stopPropagation();

      timeout = setTimeout(() => {
        if (sourceExists(source_id) !== false) {
          nastavViditelnostVrstvy(typ, source_id, "visible");
        } else {
          // ak taky zdroj nemam, musim ho najprv vytvoritt
          zobrazDataNaMape(
            { id: id, typ: typ, hover: true, nazov: nazov },
            false
          );
        }
      }, 300);
    }
  };

  const mouseOut = function (event) {
    if (!typ || !id) {
      return false;
    }

    if (!source_id) {
      return false;
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    let stav = get(user, "options.mapa.stav", false) || {};
    if (get(stav[source_id]) === undefined) {
      event.preventDefault();
      event.stopPropagation();

      // timeout = setTimeout(() => {
      if (sourceExists(source_id) !== false) {
        nastavViditelnostVrstvy(typ, source_id, "none");
      }
      // }, 300);
    }
  };

  async function onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    // event.target.removeEventListener("mouseover", mouseOver);
    // event.target.removeEventListener("mouseout", mouseOut);

    if (!source_id) {
      return false;
    }

    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }

    if (sourceExists(source_id) !== false) {
      const vrstvy = vratVrstvyMapyPodlaTypu(typ);
      // z api vratim geojson data
      const sourceData = await vratGeojsonData(typ, id);
      if (!sourceData) {
        return false;
      }

      nastavViditelnostVrstvy(typ, source_id, "visible");
      hooksStore.doAction(
        "ulozVrstvyDoStavu",
        { id: id, gistyp: typ, nazov: nazov },
        source_id,
        sourceData,
        vrstvy[0].typ_vrstvy
      );
      pointTo(sourceData, vrstvy[0].typ_vrstvy);
    } else {
      // ak taky zdroj nemam, musim ho najprv vytvoritt
      await zobrazDataNaMape({ id: id, typ: typ, nazov: nazov });
    }
    hooksStore.doAction("zobrazPopUpOknoPodlaSourceId", source_id, [
      typ,
      id,
      typ,
      nazov,
    ]);
    tableItemLinkClick(data);
  }

  onDestroy(() => {
    unsubscribeUserStore();
    if (element) {
      element.removeEventListener("mouseover", mouseOver);
      element.removeEventListener("mouseout", mouseOut);
      element.removeEventListener("click", onClick);
    }
  });

  onMount(() => {
    if (element) {
      element.addEventListener("mouseover", mouseOver);
      element.addEventListener("mouseout", mouseOut);
      element.addEventListener("click", onClick);
    }
  });
</script>

{#if data.id}
  <span
    class="color__text--{vratKodFarbyPodlaTypu(
      data.destination.match(/^([a-z]+)/)[0]
    )}"
    bind:this={element}>{data.title}</span
  >
{/if}

<style lang="scss">
  span {
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
</style>
